// import { all } from "redux-saga/effects";
import { combineReducers } from "redux";

import { authReducer } from "./modules/AuthModule/authSlice";
import { orgReducer } from "./modules/orgModule/orgSlice";


export const rootReducer = combineReducers({
  auth: authReducer,
  org: orgReducer
});
